<template>
  <header id="siteHeader">

    <transition name="fade" mode="out-in">

      <template v-if="isSubscriptionFlow">
        <div>
          <div id="header-desktop" class="header c-bg-white">
            <div class="container">
              <div class="header-grid bb-1 p-relative">
                <div></div>

                <div class="logo-wrapper desktop ml-a mr-a">
                  <a href="/">
                    <img class="logo" src="@/assets/images/logo.svg" alt="Magazyn Pismo"/>
                  </a>
                </div>

                <div class="header-control">
                  <span v-if="!userAuthenticated" class="account t-uppercase pointer mr-2" @click="openPopup()">
                    {{ $content.login}}
                  </span>

                  <a v-if="userAuthenticated" class="user-icon mr-2" href="/panel/moj-profil/">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path
                        d="M437.019531 74.980469C388.667969 26.628906 324.378906 0 256 0 187.617188 0 123.332031 26.628906 74.980469 74.980469 26.628906 123.332031 0 187.617188 0 256c0 68.378906 26.628906 132.667969 74.980469 181.019531C123.332031 485.371094 187.617188 512 256 512c68.378906 0 132.667969-26.628906 181.019531-74.980469C485.371094 388.667969 512 324.378906 512 256c0-68.382812-26.628906-132.667969-74.980469-181.019531zm-308.679687 367.40625C139.046875 380.738281 192.46875 335.265625 256 335.265625c63.535156 0 116.953125 45.472656 127.660156 107.121094C347.3125 467.359375 303.335938 482 256 482s-91.3125-14.640625-127.660156-39.613281zm46.261718-218.519531c0-44.886719 36.515626-81.398438 81.398438-81.398438s81.398438 36.515625 81.398438 81.398438c0 44.882812-36.515626 81.398437-81.398438 81.398437S174.601562 268.75 174.601562 223.867188zm235.042969 197.710937c-8.074219-28.699219-24.109375-54.738281-46.585937-75.078125-13.789063-12.480469-29.484375-22.328125-46.359375-29.269531 30.5-19.894531 50.703125-54.3125 50.703125-93.363281 0-61.425782-49.976563-111.398438-111.402344-111.398438s-111.398438 49.972656-111.398438 111.398438c0 39.050781 20.203126 73.46875 50.699219 93.363281-16.871093 6.941406-32.570312 16.785156-46.359375 29.265625-22.472656 20.339844-38.511718 46.378906-46.585937 75.078125C57.882812 380.273438 30 321.335938 30 256 30 131.382812 131.382812 30 256 30s226 101.382812 226 226c0 65.339844-27.882812 124.277344-72.355469 165.578125zm0 0"/>
                    </svg>
                  </a>

                  <a class="search" href="/wyniki-wyszukiwania/">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2"
                         viewBox="0 0 16 16">
                      <path
                        d="M.3 14.3l4.2-4.2c.2-.2.5-.3.8-.3C4.5 8.8 4 7.4 4 6c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6c-1.4 0-2.8-.5-3.8-1.4 0 .3 0 .6-.3.8l-4.2 4.2c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.3-.4-.9 0-1.3zm9.7-3.8c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5-4.5 2-4.5 4.5 2 4.5 4.5 4.5z"
                        style="fill-rule:nonzero"/>
                    </svg>
                  </a>
                </div>
              </div>

              <nav class="c-bg-white">
                <ul class="menu">
                  <li
                    class="menu-item"
                    v-for="(item) in $appInfo.menu_links"
                    :key="item.page_id">
                    <a :href="item.url">{{ item.name }}</a>
                    <ul v-if="item.children"
                        class="submenu">
                      <li
                        class="submenu-item"
                        v-for="subitem in item.children"
                        :key="subitem.page_id">
                        <a :href="subitem.url">{{ subitem.name }}</a>
                      </li>
                    </ul>
                  </li>
                  <li class="menu-item">
                    <a class="highlighted" href="/prenumerata/">{{ $content.subscription }}</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>


          <div id="header-mobile" class="header bb-1">
            <button class="menu-btn" :class="{ 'open': menuOpened }" @click="menuOpened = !menuOpened">
              <span class="menu-btn__burger"></span>
            </button>

            <div class="logo-wrapper">
              <a href="/">
                <img class="logo" src="@/assets/images/logo.svg" alt="Magazyn Pismo"/>
              </a>
            </div>

            <div class="header-control">
              <a
                class="t-uppercase highlighted mr-2"
                v-if="!userAuthenticated || noSubscription"
                href="/prenumerata/">
                {{ $content.buy_cot }}
              </a>

              <span
                v-if="!userAuthenticated" class="account t-uppercase pointer mr-1" @click="openPopup()">
                  {{ $content.login }}
                </span>

              <a v-if="userAuthenticated" class="user-icon mr-2" href="/panel/moj-profil/">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path
                    d="M437.019531 74.980469C388.667969 26.628906 324.378906 0 256 0 187.617188 0 123.332031 26.628906 74.980469 74.980469 26.628906 123.332031 0 187.617188 0 256c0 68.378906 26.628906 132.667969 74.980469 181.019531C123.332031 485.371094 187.617188 512 256 512c68.378906 0 132.667969-26.628906 181.019531-74.980469C485.371094 388.667969 512 324.378906 512 256c0-68.382812-26.628906-132.667969-74.980469-181.019531zm-308.679687 367.40625C139.046875 380.738281 192.46875 335.265625 256 335.265625c63.535156 0 116.953125 45.472656 127.660156 107.121094C347.3125 467.359375 303.335938 482 256 482s-91.3125-14.640625-127.660156-39.613281zm46.261718-218.519531c0-44.886719 36.515626-81.398438 81.398438-81.398438s81.398438 36.515625 81.398438 81.398438c0 44.882812-36.515626 81.398437-81.398438 81.398437S174.601562 268.75 174.601562 223.867188zm235.042969 197.710937c-8.074219-28.699219-24.109375-54.738281-46.585937-75.078125-13.789063-12.480469-29.484375-22.328125-46.359375-29.269531 30.5-19.894531 50.703125-54.3125 50.703125-93.363281 0-61.425782-49.976563-111.398438-111.402344-111.398438s-111.398438 49.972656-111.398438 111.398438c0 39.050781 20.203126 73.46875 50.699219 93.363281-16.871093 6.941406-32.570312 16.785156-46.359375 29.265625-22.472656 20.339844-38.511718 46.378906-46.585937 75.078125C57.882812 380.273438 30 321.335938 30 256 30 131.382812 131.382812 30 256 30s226 101.382812 226 226c0 65.339844-27.882812 124.277344-72.355469 165.578125zm0 0" />
                </svg>
              </a>

              <a class="search mr-1" href="/wyniki-wyszukiwania/">
                <svg xmlns="http://www.w3.org/2000/svg"
                     style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2"
                     viewBox="0 0 16 16">
                  <path
                    d="M.3 14.3l4.2-4.2c.2-.2.5-.3.8-.3C4.5 8.8 4 7.4 4 6c0-3.3 2.7-6 6-6s6 2.7 6 6-2.7 6-6 6c-1.4 0-2.8-.5-3.8-1.4 0 .3 0 .6-.3.8l-4.2 4.2c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.4-.3-.4-.9 0-1.3zm9.7-3.8c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5-4.5 2-4.5 4.5 2 4.5 4.5 4.5z"
                    style="fill-rule:nonzero"/>
                </svg>
              </a>
            </div>
            <transition name="slide">
              <div id="mobile-menu" class="mobile-nav" v-show="menuOpened">
                <nav class="c-bg-white">
                  <ul class="mobile-menu">
                    <li
                      class="menu-item bb-1 p-relative"
                      v-for="(item) in $appInfo.menu_links"
                      :key="item.page_id">
                      <a :href="item.url">
                        {{ item.name }}
                      </a>
                      <button
                        v-if="item.children"
                        class="submenu-arrow"
                        @click="toggleSubmenu(item.page_id)"></button>
                      <ul v-if="item.children"
                          class="mobile-submenu"
                          :class="{ open: activeSubmenu === item.page_id }"
                      >
                        <li
                          class="submenu-item"
                          v-for="subitem in item.children"
                          :key="subitem.page_id">
                          <a :href="subitem.url">{{ subitem.name }}</a>
                        </li>
                      </ul>
                    </li>
                    <li class="menu-item bb-1">
                      <a class="highlighted" href="/prenumerata/">{{ $content.subscription }}</a>
                    </li>
                    <li v-if="userAuthenticated" class="menu-item bb-1">
                      <a href="/panel/moj-profil/">{{ $content.my_profile }}</a>
                    </li>
                    <li v-if="!userAuthenticated" class="menu-item bb-1">
                      <span @click="openPopup()">{{ $content.login}}</span>
                    </li>
                    <li v-else class="menu-item bb-1">
                      <a href="/wp-login.php?action=logout">{{ $content.logout}}</a>
                    </li>
                  </ul>

                  <div class="menu-social">
                    <ul>
                      <li class="social-item"
                          v-for="(s, index) in socials"
                          :key="index">
                        <a :href="s.url"
                           :class="s.code"
                           target="_blank"
                           :title="s.title"></a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </transition>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="container c-bg-white p-relative">
          <div class="header-checkout bb-1">
            <div class="logo-wrapper mr-a ml-a">
              <img class="logo" src="@/assets/images/logo.svg" alt="Magazyn Pismo"/>
            </div>
          </div>
          <button class="back-btn" @click="prevStep()" title="wróć">
            <img src="@/assets/images/left-chevron.svg" alt="wróć"/>
          </button>
        </div>
      </template>

    </transition>
  </header>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'SiteHeader',
    data() {
      return {
        menuOpened: false,
        activeSubmenu: '',
        socials: [
          { code: 'facebook', title: 'Facebook', url: 'https://facebook.com/pismo.magazynopinii' },
          { code: 'twitter', title: 'Twitter', url: 'https://twitter.com/magazynpismo' },
          { code: 'mail', title: 'Email', url: 'mailto:redakcja@magazynpismo.pl' }
        ]
      }
    },
    computed: {
      isSubscriptionFlow() {
        return this.activeStep === 'SelectPlanStep' || this.activeStep === 'GiftForm'
      },
      noSubscription() {
        return !this.subscriptionType || this.subscriptionType === '0' || this.subscriptionType === 'free';
      },
      ...mapGetters({
        activeStep: 'GET_ACTIVE_STEP',
        userAuthenticated: 'GET_USER_AUTHENTICATED',
        subscriptionType: 'GET_USER_SUBSCRIPTION_TYPE'
      })
    },
    methods: {
      openPopup() {
        this.$store.state.modalOpened = true;
      },
      prevStep() {
        let step = this.$store.state.activeStep;
        switch (step) {
          case 'AuthStep':
            this.$store.commit('setActiveStep', { activeStep: 'SelectPlanStep' });
            break;
          case 'DeliveryStep':
            if (!this.$store.state.userAuthenticated) {
              this.$store.commit('setActiveStep', { activeStep: 'AuthStep' });
            } else {
              this.$store.commit('setActiveStep', { activeStep: 'SelectPlanStep' });
            }
            break;
          case 'SummaryStep':
            if (!this.$store.state.selectedPlan.is_shipping && !this.$store.state.giftData.isGift) {
              this.$store.commit('setActiveStep', { activeStep: 'SelectPlanStep' });
            } else {
              this.$store.commit('setActiveStep', { activeStep: 'DeliveryStep' });
            }
            break;
          default:
            break;
        }
      },
      toggleSubmenu(id) {
        if (this.activeSubmenu === id) {
          this.activeSubmenu = ''
        } else {
          this.activeSubmenu = id;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../scss/mixins';

  #siteHeader {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }

  .header {
    padding: 0 10px;
    position: relative;
    background: var(--color-white);

    &-wrapper {
      display: flex;
      height: 100%;
      align-items: center;
      position: relative;
    }
    &-checkout {
      display: flex;
      justify-content: center;
    }
  }
  #header-mobile {
    height: 76px;
    display: grid;
    grid-template-columns: 32px 1fr auto;
    grid-column-gap: 1em;
    align-items: center;
    @include respond-to('desktop') {
      display: none;
    }
  }

  #header-desktop {
    display: none;
    @include respond-to('desktop') {
      display: block;
    }
    .header-grid {
      height: 80px;
      display: grid;
      grid-template-columns: 1fr 240px 1fr;
      justify-items: center;
      align-items: center;
      .header-control {
        justify-self: flex-end;
      }
    }
  }

  .logo-wrapper {
    a {
      display: inline-flex;
    }
    .logo {
      height: 76px;
      max-width: 90px;
      @include respond-to('desktop') {
        height: 79px;
        max-width: 180px;
      }
    }
  }

  .menu-btn {
    $size: 28px;
    cursor: pointer;
    width: $size;
    height: $size;
    padding: 0;
    background: transparent;
    margin: auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    @include respond-to('desktop') {
      padding: 0;
    }
    &__burger {
      $gap: 8px;
      &, &::before, &::after {
        width: $size;
        height: 4px;
        background: var(--color-darkgray);
        transition: all .5s ease-in-out;
        left:0;
      }
      &::before, &::after {
        content: '';
        position: absolute;
      }
      &::before {
        transform: translateY(-$gap);
      }
      &::after {
        transform: translateY($gap);
      }
    }
    &.open {
      .menu-btn__burger {
        transform: translateX(-50px);
        background: transparent;
        box-shadow: none;
        &::before {
          transform: rotate(45deg) translate(35px, -35px);
        }
        &::after {
          transform: rotate(-45deg) translate(35px, 35px);
        }
      }
    }
  }

  .menu {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    &-item {
      display: inline-block;
      color: var(--color-gray);
      cursor: pointer;
      font-size: var(--font-16);
      font-variant: all-small-caps;
      text-transform: uppercase;
      position: relative;
      letter-spacing: 1px;
      transition: color 200ms ease-in;
      margin: 0 .8em;
      padding-top: 15px;
      padding-bottom: 15px;
      &:not(:last-child)::after {
        @include respond-to('desktop') {
          content: '|';
        }
        position: absolute;
        right: -14px;
        font-weight: 700;
      }

      @include respond-to('desktop') {
        padding-top: 10px;
        padding-bottom: 10px;
      }

      &:hover {
        color: var(--color-black);

        > .submenu {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }

  .highlighted {
    color: var(--color-pink);
    position: relative;
    padding: {
      left: 10px;
      right: 10px;
    }

    &::before, &::after {
      content: "";
      display: inline-block;
      border-top: 1px solid var(--color-pink);
      border-bottom: 1px solid var(--color-pink);
      height: 2em;
      width: .5em;
      position: absolute;
      top: -.3em;
    }
    &::before {
      border-left: 1px solid var(--color-pink);
      left: 0;
    }
    &::after {
      border-right: 1px solid var(--color-pink);
      right: 0;
    }
  }

  .submenu {
    background: var(--color-white);
    display: flex;
    flex-direction: column;
    position: absolute;
    opacity: 0;
    visibility: hidden;
    top: 100%;
    left: -14px;
    width: 220px;
    transition: all ease-in 200ms;
    z-index: 10;

    &-item {
      padding: 10px 0;
      color: var(--color-gray);
      transition: color 200ms ease-in;
      @include respond-to('desktop') {
        padding: 6px 0;
      }

      &:hover {
        color: var(--color-black);
      }
    }

    &-arrow {
      cursor: pointer;
      display: inline-block;
      width: 22px;
      height: 22px;
      background: url('../assets/images/arrow.png') no-repeat;
      background-size: contain;
      margin: auto 0;
      top: 15px;
      right: 0;
      position: absolute;
    }
  }

  .back-btn {
    padding: 0;
    border: none;
    background: transparent;
    top: 0;
    bottom: 0;
    margin: auto 0;
    left: 15px;
    cursor: pointer;
    position: absolute;

    img {
      width: 32px;
      height: 32px;
    }
  }

  .header-control {
    font-size: var(--font-16);
    font-variant: all-small-caps;
    letter-spacing: 2px;
    color: var(--color-gray);
    display: flex;
    align-items: center;
    margin-top: auto;
    margin-bottom: auto;

    .account {
      color: var(--color-gray);
      transition: color 200ms ease-in;

      &:hover {
        color: var(--color-black);
      }
    }

    .search {
      $size: 18px;
      width: $size;
      height: $size;
      @include respond-to('small') {
        $size: 24px;
        width: $size;
        height: $size;
      }

      svg {
        fill: var(--color-gray);
        transition: fill 200ms ease-in;
      }

      &:hover svg {
        fill: var(--color-black);
      }
    }

    .user-icon {
      $size: 24px;
      width: $size;
      height: $size;

      svg {
        fill: var(--color-gray);
        transition: fill 200ms ease-in;
      }

      &:hover svg {
        fill: var(--color-black);
      }
    }
  }

  .mobile {
    &-nav {
      position: absolute;
      background: var(--color-white);
      top: 100%;
      left: 0;
      width: 100%;
      height: calc(100vh - 73px);
    }

    &-menu {
      display: flex;
      flex-direction: column;
    }

    &-submenu {
      display: flex;
      flex-direction: column;
      max-height: 0;
      transition: all 400ms ease-in;
      overflow: hidden;
      opacity: 0;

      &.open {
        max-height: 300px;
        opacity: 1;
      }
    }
  }

  .menu-social {
    display: contents;
    ul {
      display: flex;
      justify-content: flex-start;
      margin-top: 20px;
    }
  }
  .social-item {
    $social-icon: 50px;
    margin: 0 15px 0 0;
    a {
      display: inline-block;
      background: transparent url('../assets/images/social-icons.png') no-repeat 0 0;
      width: $social-icon;
      height: $social-icon;
      &.facebook {
        @include image-sprite($social-icon, 0);
      }
      &.twitter {
        @include image-sprite($social-icon, 1);
      }
      &.mail {
        @include image-sprite($social-icon, 3);
      }
    }
  }

  .mobile-nav {
    overflow: auto;
  }
</style>
